<template>
  <div>
    <div id="label-seed-wrapper" v-if="loadingLine && farmer && labels.length">
      <div
        v-for="(label, labelIndex) in labels"
        :key="`seeds-label-${labelIndex}`"
      >
        <!-- label wrapper -->
        <div
          style="
            width: calc(96mm * 1.55);
            height: calc(66mm * 1.55);
            display: inline-block;
            border: 2px solid black;
            margin: 3.5mm;
            overflow: hidden;
          "
        >
          <!-- row 1 -->
          <div
            style="
              display: flex;
              justify-content: space-between;
              align-items: stretch;
              height: 37.5%;
            "
          >
            <div
              style="
                width: 62.5%;
                display: flex;
                align-items: stretch;
                justify-content: stretch;
                flex-direction: column;
              "
            >
              <h3
                style="
                  margin-bottom: 0px;
                  font-weight: bold;
                  display: flex;
                  align-items: center;
                "
              >
                <span
                  style="
                    border-right: 2px solid black;
                    text-align: center;
                    padding: 5px 10px;
                  "
                >
                  {{ label.label_code }}
                </span>
                <div style="flex: 1; text-align: center">D-{{ farmer.id }}</div>
              </h3>
              <h1
                style="
                  margin-bottom: 0px;
                  border: 2px solid black;
                  border-left: 0px;
                  border-right: 0px;
                  flex: 1;
                  padding: 5px;
                  font-weight: bold;
                  font-size: 30px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  text-align: center;
                "
              >
                <span v-if="loadingLine.status == 1">
                  {{ farmer.farmer_name }}
                </span>
                <span v-else>
                  {{ farmer.pic_name }}
                </span>
              </h1>
            </div>
            <div
              style="
                text-align: center;
                border: 2px solid black;
                border-top: 0px;
                border-right: 0px;
                width: 37.5%;
                display: flex;
                justify-content: center;
                align-items: center;
                flex-direction: column;
              "
            >
              <h3 style="font-weight: bold">{{ label.rel_tree_id }}</h3>
              <h1 style="font-size: 50px; font-weight: bold">
                {{ label.amount }}
              </h1>
            </div>
          </div>
          <!-- row 2 -->
          <div
            style="
              display: flex;
              justify-content: space-between;
              align-items: stretch;
              height: 62.5%;
              padding-top: 0px;
              overflow: hidden;
            "
          >
            <!-- QR -->
            <div
              style="
                width: 35.6%;
                overflow: hidden;
                position: relative;
                border-right: 2px solid black;
              "
            >
              <div
                style="
                  flex: 1;
                  display: flex;
                  justify-content: center;
                  align-items: center;
                "
              >
                <vue-qr
                  :logoSrc="$_config.logo.black"
                  :text="`${label.id}`"
                  :size="200"
                  style=""
                ></vue-qr>
              </div>
              <h1
                style="
                  position: absolute;
                  bottom: -5px;
                  text-align: center;
                  background-color: white;
                  left: 0;
                  right: 0;
                  border-top: 2px solid #000;
                  font-weight: bold;
                "
              >
                {{ label.id }}
              </h1>
            </div>
            <!-- Description -->
            <div style="flex: 1">
              <div style="display: flex; align-items: center; width: 100%">
                <h1
                  style="
                    font-weight: bold;
                    margin-bottom: 0px;
                    flex: 1;
                    padding: 7px 10px;
                    border-right: 2px solid #000;
                  "
                >
                  {{ label.lahan_no.slice(0, 10) }}
                </h1>
                <h1
                  style="
                    flex: 1;
                    font-weight: bold;
                    margin-left: 5px;
                    margin-bottom: 0px;
                    text-align: center;
                  "
                >
                  {{ label.lahan_no.slice(-3) }}
                </h1>
              </div>
              <!-- FF Name -->
              <h1
                v-if="loadingLine.status != 2"
                style="
                  font-weight: bold;
                  border: 2px solid black;
                  padding: 5px;
                  border-left: 0px;
                  border-right: 0px;
                  text-align: center;
                "
              >
                FF: {{ loadingLine.ff_name }}
              </h1>
              <div style="padding-left: 10px">
                <table
                  class="table table-detail mb-0 table-label-bibit"
                  style="font-size: 15px; font-weight: bold"
                >
                  <tbody>
                    <!-- Tanggal -->
                    <tr>
                      <td
                        class="nowrap-table"
                        style="border-top: none !important"
                      >
                        Tanggal
                      </td>
                      <td
                        class="nowrap-table"
                        style="border-top: none !important"
                      >
                        &emsp;:&nbsp;
                      </td>
                      <td style="border-top: none !important">
                        {{ loadingLine.distribution_date | parse("longDate") }}
                      </td>
                    </tr>
                    <!-- Carbon / Non-Carbon -->
                    <tr>
                      <td class="nowrap-table">Tujuan Project</td>
                      <td class="nowrap-table">&emsp;:&nbsp;</td>
                      <td>
                        {{
                          label.project_purpose | parse("project_type_lahan")
                        }}
                      </td>
                    </tr>
                    <!-- Project -->
                    <tr>
                      <td class="nowrap-table">Project</td>
                      <td class="nowrap-table">&emsp;:&nbsp;</td>
                      <td>
                        {{ label.project_code || "-" }}
                      </td>
                    </tr>
                    <!-- Lokasi -->
                    <tr>
                      <td class="nowrap-table">Lokasi</td>
                      <td class="nowrap-table">&emsp;:&nbsp;</td>
                      <td>
                        {{ loadingLine.location_distribution }}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
        <!-- page-break -->
        <p
          v-if="labelIndex + 1 > labels.length"
          style="page-break-after: always"
        ></p>
      </div>
    </div>
    <b-card v-else title="Label Bibit">
      <h1>Data tidak ditemukan!</h1>
    </b-card>
  </div>
</template>

<script>
export default {
  name: "NurseryManagementLabelSeed",

  data: () => ({
    loadingLine: null,
    farmer: null,
    labels: [],
  }),

  mounted: async function () {
    await this.initData();
  },

  methods: {
    initData: async function () {
      const loading = this.$_alert.loading("Memuat data ...");
      try {
        const route = this.$route.query;
        if (!route.loading_line_id) {
          loading.close();
          setTimeout(() => {
            this.$_alert.error(null, "Gagal", "Data tidak ditemukan!");
          }, 100);
          return;
        }
        this.loadingLine = await this.$_api
          .single("loading_line", null, route.loading_line_id)
          .then((res) => res.data);
        if (this.loadingLine) {
          const listFarmers = this.loadingLine.detail_farmers;
          const findFarmer = listFarmers.find(
            (v) =>
              (this.loadingLine.status == 1 &&
                v.farmer_no == route.farmer_no) ||
              (this.loadingLine.status == 2 && v.pic_no == route.pic_no)
          );
          if (findFarmer) {
            this.farmer = findFarmer;
            const labels = findFarmer.detail_labels;
            this.labels = labels
              .filter((v) => {
                if (this.$route.query.project_purpose) {
                  return v.project_purpose == this.$route.query.project_purpose;
                } else {
                  return true;
                }
              })
              .map((v) => {
                const nom = String(v.label_code.split("/")[0]).padStart(3, "0");
                return {
                  ...v,
                  nom: nom,
                };
              })
              .sort((a, b) => {
                return (
                  a.rel_tree_id.localeCompare(b.rel_tree_id) ||
                  a.lahan_no.localeCompare(b.lahan_no) ||
                  a.nom.localeCompare(b.nom)
                );
              });
            setTimeout(() => {
              window.print();
            }, 1000);
          }
        }
      } catch (err) {
        console.log("initData() error", err);
        this.$_alert.error(err);
      } finally {
        loading.close();
      }
    },
  },
};
</script>
<style lang="scss">
.table-label-bibit {
  tbody {
    tr {
      td {
        padding: 0px !important;
      }
    }
  }
}
@media print {
  @page {
    size: landscape !important;
  }
}
</style>


// WEBPACK FOOTER //
// src/default-page/print/label-seed.vue